import { useState } from "react";

export const useIsInitializing = () => {
  const [isInitializing, setIsInitializing] = useState(true);
  return { isInitializing, setIsInitializing };
};
